import React, { useEffect, useState } from 'react';
import { List } from 'antd';
import moment from 'moment';
import { usePromise, Button } from '@digital/ui';

import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import { IItemMsgComentario } from '@app/types/core.types';

import { Space } from '../Space';


interface IItemListComentarioProps {
    allComentarios: IItemMsgComentario[];
    recarregarMensagem: boolean;
    loadAllComentarios: () => Promise<IItemMsgComentario[]>;
    verificarTemComentarios?: (value: boolean) => void;
}

const ItemListComentario = ({ allComentarios, loadAllComentarios, recarregarMensagem, verificarTemComentarios }: IItemListComentarioProps) => {

    const [allComments, setAllComments] = useState<IItemMsgComentario[]>([]);

    useEffect(() => {
        if (allComentarios.length == 0) {
            loadAllComentarios()
                .then((apiCommments) => {
                    if (apiCommments.length > 0) {
                        verificarTemComentarios && verificarTemComentarios(true);
                        setAllComments(apiCommments);
                    }
                });
        } else {
            setAllComments(allComentarios);
        }
    }, [])

    useEffect(() => {
        loadAllComentarios()
            .then((apiCommments) => {
                if (apiCommments.length > 0) {
                    verificarTemComentarios && verificarTemComentarios(true);
                    setAllComments(apiCommments);
                }
            });
    }, [recarregarMensagem])


    return (
        <div>
            <List
                itemLayout="horizontal"
                dataSource={allComments}
                renderItem={(item: IItemMsgComentario) => (
                    <>
                        <List.Item>
                            {item.possuiArquivo ? (
                                <List.Item.Meta
                                    title={
                                        <a href={'#' + item.id}>
                                            {item.usuario + ' - ' + convertUTCtoLocal(moment(item.data)).toLocaleString()}
                                        </a>
                                    }
                                    description={
                                        <>
                                            {item.mensagem}
                                            <br />
                                            <Button
                                                type="link"
                                                icon="arrows-circled_down_2"
                                                onClick={() => {
                                                    // DownloadAnexoLinhaItem(item.id);
                                                }}>
                                                Baixar Arquivo
                                            </Button>
                                        </>
                                    }
                                    className={item.cssClass || '' }
                                />
                            ) : (
                                <List.Item.Meta
                                    title={
                                        <a href={'#' + item.id}>
                                            {item.usuario + ' - ' + convertUTCtoLocal(moment(item.data)).toLocaleString()}
                                        </a>
                                    }
                                    description={item.mensagem}
                                    className={item.cssClass || '' }
                                />
                            )}
                        </List.Item>
                        <Space mb={8} />
                    </>
                )}
            />
            <Space mb={8} />
        </div>
    );
};

export default ItemListComentario;